/* Explain — the rail's switch for the help dots (audit cut 3, Ale
 * 2026-09-05). The 20 Aug ruling asked for guidance ON by default with a
 * permanent toggle; the toggle was never built — this is it. Off hides
 * every ? on every surface. The state is the officer's own and lives
 * server-side (PUT /api/guidance/mode), so it holds across sessions.
 * A switch: reachable by Tab, flipped by Space or Enter, named by its
 * visible label. Disabled until the first read answers — a switch must
 * not claim a state it does not know. */

import { setExplainMode, useGuidanceState } from './api'

export default function ExplainToggle() {
  const state = useGuidanceState()
  const on = state?.explain_mode ?? false
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      className={`explain-toggle${on ? ' on' : ''}`}
      data-testid="explain-toggle"
      title="Show or hide the ? help dots"
      disabled={state === null}
      onClick={() => setExplainMode(!on)}
    >
      <span className="et-label">Explain</span>
      <span className="et-switch" aria-hidden="true">
        <span className="et-knob" />
      </span>
    </button>
  )
}
